import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from 'ui-components/Skeleton'

export default function ListSkeleton({ height }) {
  return (
    <>
      <Skeleton variant="rect" height={height} component="p" />
      <Skeleton variant="rect" height={height} component="p" />
      <Skeleton variant="rect" height={height} component="p" />
    </>
  )
}

ListSkeleton.propTypes = {
  height: PropTypes.string,
}

ListSkeleton.defaultProps = {
  height: '50px',
}
